import React from 'react';
import { Search, X } from 'lucide-react';
import { Input } from '../ui/Input';
import { IconButton } from '../ui/Button';

/**
 * Tailwind Search Bar for Editor
 * Uses our custom Input and IconButton components
 */
export const VoiceSearchBarTailwind = ({ value, onChange, onClear, placeholder = "Search voices..." }) => {
    return (
        <div className="tw:relative tw:w-full tw:mb-4">
            <div className="tw:absolute tw:inset-y-0 tw:left-0 tw:flex tw:items-center tw:pl-3 tw:pointer-events-none tw:z-10">
                <Search size={16} className="tw:text-gray-400" />
            </div>
            <Input
                type="text"
                value={value}
                onChange={(e) => onChange(e.target.value)}
                placeholder={placeholder}
                inputClassName="tw:pl-10 tw:pr-10"
            />
            {value && (
                <div className="tw:absolute tw:inset-y-0 tw:right-0 tw:flex tw:items-center tw:pr-2">
                    <IconButton
                        icon={X}
                        onClick={onClear}
                        variant="ghost"
                        size="sm"
                        className="tw:text-gray-400 hover:tw:text-gray-600"
                    />
                </div>
            )}
        </div>
    );
};

/**
 * Bootstrap 5 Search Bar for Voices Page
 * Uses standard Bootstrap classes for consistency with dashboard
 */
export const VoiceSearchBarBootstrap = ({ value, onChange, onClear, placeholder = "Search voices..." }) => {
    return (
        <div className="position-relative mb-3">
            <div className="position-absolute" style={{ left: '12px', top: '50%', transform: 'translateY(-50%)', pointerEvents: 'none' }}>
                <Search size={16} style={{ color: 'var(--bs-secondary-color)' }} />
            </div>
            <input
                type="text"
                value={value}
                onChange={(e) => onChange(e.target.value)}
                placeholder={placeholder}
                className="form-control"
                style={{ paddingLeft: '38px', paddingRight: value ? '38px' : '12px' }}
            />
            {value && (
                <button
                    type="button"
                    onClick={onClear}
                    className="btn btn-link position-absolute"
                    style={{
                        right: '4px',
                        top: '50%',
                        transform: 'translateY(-50%)',
                        padding: '4px',
                        color: 'var(--bs-secondary-color)',
                        textDecoration: 'none'
                    }}
                >
                    <X size={16} />
                </button>
            )}
        </div>
    );
};

